import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import MdmIcon from '../components/atoms/Global/MdmIcon.vue';
Vue.component('mdm-icon', MdmIcon);